export default __webpack_public_path__ + "static/media/bg1.b715d2e5.svg";